import $ from "jquery";

export default function(uuid) {
  $(`.${uuid}`).on('click', (event) =>
    $(event.currentTarget).parents('tr').find(':radio').each(function(){ this.checked = false; })
  );
}
